import keys from '@debbie/common/dist/cache/keys.js';
import { IntegrationId, } from '@debbie/common/dist/integrations/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as integrationsAPI from '@debbie/cortex/dist/api/integrations.js';
import { h } from '@debbie/cortex/dist/index.js';
import { integrationActivationsEntity, useCreditorIntegrationActivations, useIntegration, useIntegrationActivation, } from '@debbie/cortex/dist/integrations/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import { template } from 'lodash-es';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import Button from '../Button.js';
import Disclaimer from '../Disclaimer.js';
import Modal from '../Modal.js';
import ActivateIntegration from './ActivateIntegration.js';
import EConomicSettings from './e-conomic/EConomicSettings.js';
import EConomicSettingsDisplay from './e-conomic/EConomicSettingsDisplay.js';
const Integration = (props) => {
    const integrationLoader = useIntegration(props.id);
    const creditorActivationsLoader = useCreditorIntegrationActivations(props.creditorId);
    const creditorActivations = h.hasData(creditorActivationsLoader)
        ? creditorActivationsLoader.data
        : null;
    const relevantActivation = creditorActivations?.find((activation) => activation.integrationId === props.id);
    const activationId = relevantActivation?.id;
    const activationLoader = useIntegrationActivation(activationId);
    const selectedOwner = useTenantId();
    const lang = useSelector((state) => state.lang);
    const [settingOptions, setSettingOptions] = useState(false);
    const [options, setOptions] = useState();
    const deactivate = useMutation(() => integrationsAPI.deactivate(activationId), {
        onSuccess: () => q.invalidate(keys.write.modify(integrationActivationsEntity, activationId)),
        onError: (err) => errorNotification(lang, err, 'update', lang.errorEntities.integration),
    });
    const reactivate = useMutation(() => integrationsAPI.reactivate(activationId), {
        onSuccess: () => q.invalidate(keys.write.modify(integrationActivationsEntity, activationId)),
        onError: (err) => errorNotification(lang, err, 'update', lang.errorEntities.integration),
    });
    useEffect(() => {
        if (h.hasData(integrationLoader)) {
            setOptions(integrationLoader.data.defaultOptions);
        }
    }, [integrationLoader]);
    if (!h.hasData(integrationLoader) ||
        !creditorActivations ||
        selectedOwner == null) {
        return null;
    }
    const integration = integrationLoader.data;
    if (props.token != null) {
        return (React.createElement(ActivateIntegration, { tenantId: selectedOwner, creditorId: props.creditorId, id: props.id, token: props.token, options: props.options }));
    }
    if (relevantActivation && !h.hasData(activationLoader)) {
        return null;
    }
    const activation = relevantActivation && h.hasData(activationLoader)
        ? activationLoader.data
        : null;
    return (React.createElement(Wrapper, null,
        React.createElement(Meta, null,
            React.createElement(Logo, { src: integration.logo }),
            React.createElement(MetaText, null,
                React.createElement(Title, null, integration.name),
                React.createElement(Short, null, integration.shortDescription),
                activation != null ? (activation.active ? (React.createElement(Button, { block: true, theme: "dangerous", loading: deactivate.isLoading, onClick: () => deactivate.mutate() }, lang.integrations.deactivate)) : (React.createElement(Button, { block: true, loading: reactivate.isLoading, onClick: () => reactivate.mutate() }, lang.integrations.reactivate))) : (React.createElement(Button, { block: true, onClick: () => {
                        if (integration.id === IntegrationId.Economic) {
                            setSettingOptions(true);
                        }
                        else {
                            window.location.href = template(integration.link)({
                                redirectUrl: encodeURIComponent(props.redirectUrl),
                            });
                        }
                    } }, lang.integrations.connect)),
                activation != null &&
                    activation.options != null &&
                    hasOptions(activation.options) ? (React.createElement(SettingsSection, null,
                    React.createElement(SettingsHeader, null, lang.integrations.integrationOptions),
                    React.createElement(IntegrationSettingsDisplay, { integrationId: integration.id, options: activation.options }))) : null)),
        React.createElement(Description, null,
            React.createElement(DescriptionImagesWrapper, null,
                React.createElement(DescriptionImages, null, integration.images.map((image) => (React.createElement(DescriptionImage, { key: image, src: image }))))),
            React.createElement(DescriptionText, null,
                React.createElement(DescriptionStyles, { dangerouslySetInnerHTML: { __html: integration.description } }))),
        settingOptions ? (React.createElement(Modal, { maxWidth: "400px", header: `${integration.name} ${lang.integrations.integrationOptions}`, onToggle: () => {
                setSettingOptions(false);
            } },
            React.createElement("form", { onSubmit: (e) => {
                    e.preventDefault();
                    window.location.href = template(integration.link)({
                        redirectUrl: encodeURIComponent(props.redirectUrl +
                            '?' +
                            new URLSearchParams({
                                options: JSON.stringify(options),
                            }).toString()),
                    });
                } },
                integration.id === IntegrationId.Economic && options != null ? (React.createElement(EConomicSettings, { options: options, setOptions: setOptions })) : null,
                React.createElement(Disclaimer, null, lang.integrations.notChangable),
                React.createElement(Button, { style: { width: '100%' } }, lang.integrations.connect)))) : null));
};
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: 860px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;
const Meta = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1em;
  padding-bottom: 1em;
  border-bottom: 1px solid ${THEME.COLOR_PRIMARY}20;
  @media (min-width: 860px) {
    width: calc(30% - 20px);
    padding-bottom: 0;
    padding-right: 20px;
    border-bottom: none;
    border-right: 1px solid ${THEME.COLOR_PRIMARY}20;
  }
`;
const MetaText = styled.div ``;
const Logo = styled.img `
  width: 100%;
  height: 64px;
  object-fit: contain;
`;
const Title = styled.h1 `
  margin: 0;
  line-height: 1.5;
  font-size: 1.5em;
`;
const Short = styled.p `
  margin: 0;
  margin-bottom: 20px;
`;
const Description = styled.div `
  width: 100%;
  @media (min-width: 860px) {
    width: 70%;
  }
`;
const DescriptionImagesWrapper = styled.div `
  width: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  margin-bottom: 1em;
`;
const DescriptionImages = styled.div `
  display: block;
  width: auto;
`;
const DescriptionImage = styled.img `
  width: 400px;
  max-width: 90%;
  height: 300px;
  object-fit: cover;
  margin-right: 10px;
  border: 1px solid lightgray;
  border-radius: 5px;
`;
const DescriptionText = styled.div `
  width: 100%;
`;
const DescriptionStyles = styled.div `
  h1,
  h2,
  h3 {
    margin: 0;
    margin-bottom: 0.2rem;
    line-height: 1.5;
  }
  h1 {
    font-size: 1.3em;
  }
  h2 {
    font-size: 1.15em;
  }
  h3 {
    font-size: 1em;
  }
  p {
    margin: 0;
    margin-bottom: 0.5rem;
    line-height: 1.5;
  }
`;
const hasOptions = (options) => {
    return options != null && Object.keys(options).length > 0;
};
const IntegrationSettingsDisplay = ({ integrationId, options, }) => {
    if (integrationId === IntegrationId.Economic) {
        return React.createElement(EConomicSettingsDisplay, { options: options });
    }
    return null;
};
const SettingsSection = styled.div `
  margin-top: 1.5em;
`;
const SettingsHeader = styled.h3 `
  margin: 0 0 0.5em 0;
  font-size: 1em;
  font-weight: 600;
`;
export default Integration;
//# sourceMappingURL=Integration.js.map